import moment from 'moment';
import secureStorage from '../controllers/secureStorage';

var reportUtils = {
    pdfTools: {
        addFooter(doc, printedBy, reportText, design_x, design_y, currentPage, totalPages) {
            doc.text(15,design_y,"Printed By: " + printedBy)
            doc.text(design_x,design_y, reportText, "right")
    
            doc.text(15,design_y+5,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA"))
            doc.text(design_x,design_y+5,"Page " + currentPage  + " of " + totalPages, "right")
        },
        addLegend(doc, legends, finalY){
            if(legends.length > 0){
                finalY += 4
                doc.text(15, finalY, 'Legend: ')
                doc.setFontSize(9)
                doc.setFontType("italic");
                var count = 0
                var batch = []
                var legendXpos = 30
                legends.forEach(function(legend) {
                    if(count%3 == 0 && count){
                        legendXpos += Math.max(...batch)
                        batch = []
                    }
                    batch.push(Math.ceil(legend.length*1.4) + 8)
                    doc.text(legendXpos, finalY + (4 * (count%3)), legend)
                    count++;
                })
                doc.setFontSize(10)
                doc.setFontType("normal");
            }
        }
    },
    csvxlsxTools: {
        getBase64Image(imgUrl) {
            var canvas = document.createElement("canvas");
            canvas.width = imgUrl.width;
            canvas.height = imgUrl.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(imgUrl, 0, 0);
            var dataURL = canvas.toDataURL("image/png");
            return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
        },
        addLegend(reportData, legends){
            // cut legends into 3 arrays
            let copyArr = [...legends]
            let sliced = []
            for (let i = 3; i > 0; i--) {
                sliced.push(copyArr.splice(0, Math.ceil(copyArr.length / i)));
            }
            console.log(legends)
            console.log('I ACTUALLY GOT IN')
            console.log(sliced)
            reportData.push(['Legend: ', ...sliced[0]])
            if(sliced.length>1) reportData.push(['', ...sliced[1]])
            if(sliced.length>2)reportData.push(['', ...sliced[2]])

            return reportData
        }
    },
    advanceFilterTools: {
        buildAdditionalParams(params, filterParams, inputLocation){
            var filter_header = ''
            var additional_params = ''

            var status_header = "([Active],[Inactive],[Phase-out])"
            if(params.status != undefined && params.status.length != 0){
                var statuses = params.status
                for (let s = 0; s < statuses.length; s++) {
                    const element = statuses[s];
                    let text;
                        switch(element) {
                        case 'A':
                            text = 'Active';
                        break;
                        case 'I':
                            text = 'Inactive';
                        break;
                        case 'P':
                            text = 'Phase-out';
                        break;
                    }
                    if(s == 0){
                        status_header = "("
                        status_header += `[${text}]`
                    } else {
                        status_header += `,[${text}]`
                        if (s == statuses.length-1){
                            status_header = ")"
                        }
                    }
                }
                additional_params += '&status=' + params.status
            }

            if(params.design_id != undefined && params.design_id != null && params.design_id.length != 0){
                additional_params += '&design_id=' + params.design_id
                filter_header += ` with Design (${filterParams.design_name})`
            }

            if(params.color_id != undefined && params.color_id != null && params.color_id.length != 0){
                additional_params += '&color_id=' + params.color_id
                filter_header += ` with Color (${filterParams.color_name})`
            }

            if(params.size_id != undefined && params.size_id != null && params.size_id.length != 0){
                additional_params += '&size_id=' + params.size_id
                filter_header += ` with Size (${filterParams.size_name})`
            }

            if(params.product_line_id != undefined && params.product_line_id != null && params.product_line_id.length != 0){
                additional_params += '&product_line_id=' + params.product_line_id
                filter_header += ` with Product Line (${filterParams.product_line_name})`
            }

            if(params.product_type != undefined && params.product_type != null && params.product_type.length != 0){
                additional_params += '&product_type=' + params.product_type
                filter_header += ` with Product Type (${filterParams.product_type_name})`
            }

            if(params.supplier_type_id != undefined && params.supplier_type_id != null && params.supplier_type_id.length != 0){
                additional_params += '&supplier_type_id=' + params.supplier_type_id
                filter_header += ` with Supplier Type (${filterParams.supplier_type_name})`
            }

            if(params.tax_type != undefined && params.tax_type != null && params.tax_type.length != 0){
                additional_params += '&tax_type=' + params.tax_type
                filter_header += ` with Tax Type (${filterParams.tax_type_name})`
            }

            if(params.barcode != undefined && params.barcode != null && params.barcode != ''){
                additional_params += '&barcode=' + params.barcode
                filter_header += ` with Barcode (${params.barcode})`
            }

            if(params.stock_no != undefined && params.stock_no != null && params.stock_no != ''){
                additional_params += '&stock_no=' + params.stock_no
                filter_header += ` with Stock No. (${params.stock_no})`
            }

            if(params.name != undefined && params.name != null && params.name != ''){
                additional_params += '&name=' + params.name
                filter_header += ` with Name (${params.name})`
            }

            if(params.retail_price != undefined && params.retail_price != null && params.retail_price != ''){
                additional_params += '&retail_price=' + params.retail_price
                filter_header += ` with Retail Price (${params.retail_price})`
            }

            if(params.category_id != undefined && params.category_id.length != 0){
                additional_params += '&category_id=' + params.category_id
                if(params.category_name != undefined){
                    filter_header += ` with Category (${filterParams.category_name})`
                }
            }

            if(params.division_id != undefined && params.division_id.length != 0){
                additional_params += '&division_id=' + params.division_id
                if(params.division_name != undefined){
                    filter_header += ` with Division (${filterParams.division_name})`
                }
            }

            if(params.department_id != undefined && params.department_id.length != 0){
                additional_params += '&department_id=' + params.department_id
                if(params.department_name != undefined){
                    filter_header += ` with Department (${filterParams.department_name})`
                }
            }

            if(params.section_id != undefined && params.section_id.length != 0){
                additional_params += '&section_id=' + params.section_id
                if(params.section_name != undefined){
                    filter_header += ` with Section (${filterParams.section_name})`
                }
            }

            if(params.supplier_id != undefined && params.supplier_id.length != 0){
                additional_params += '&supplier_id=' + params.supplier_id
                filter_header += ` with Supplier (${filterParams.supplier_name})`
            } else {
                filter_header += ` with Supplier ([All Suppliers])`
            }

            if(params.brand_id != undefined && params.brand_id.length != 0){
                additional_params += '&brand_id=' + params.brand_id
                filter_header += ` with Brand (${filterParams.brand_name})`
            }

            if(inputLocation && inputLocation.length > 0){
                additional_params += '&location_path=' + inputLocation
            }

            if(params.property_tag != undefined && params.property_tag.length != 0){
                filter_header += ` with Property Tag (${filterParams.property_tag_name})`
            }

            return {filter_header: filter_header, additional_params: additional_params, status_header: status_header}
        }
    },
    openNotificationWithIcon(component_x, type, msg) {
        if(type == 'error'){
            component_x.$notification[type]({
                message: 'Export Error',
                description: msg
            });
        }else if(type == 'warning'){
            component_x.$notification[type]({
                message: 'No Data Found',
                description: msg
            });
        }
    },
    buildFromToHeaders(component_x, inputGroupBy, inputDate){
        let from_date = ''
        let to_date = ''

        let from_header = ''
        let to_header = ''

        var inputFrom = component_x.inputFrom
        var inputTo = component_x.inputTo

        if(inputGroupBy != 'monthly'){
            if(inputDate.length == 0){
                reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                return
            }

            from_date = inputDate[0].format('YYYY-MM-DD HH:mm:ss');
            to_date = inputDate[1].format('YYYY-MM-DD HH:mm:ss');

            from_header = inputDate[0].format('MMMM DD, YYYY')
            to_header = inputDate[1].format('MMMM DD, YYYY')
        } else {
            if(inputFrom == null || inputTo == null){
                reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                return
            }

            from_date = moment(inputFrom).startOf('month').format('YYYY-MM-DD HH:mm:ss');
            to_date = moment(inputTo).endOf('month').format('YYYY-MM-DD HH:mm:ss');

            from_header = moment(inputFrom).startOf('month').format('MMMM DD, YYYY')
            to_header = moment(inputTo).endOf('month').format('MMMM DD, YYYY')
        }

        return {from_date: from_date, to_date: to_date, from_header, to_header}
    }
}

const dissectReportFilters = (parameters, displayOptions, formatOptions) => {
  let parameterKeys = Object.keys(parameters);
  let productFilters = secureStorage.getItem("productFilters") || [];

  delete productFilters.inputDesign;
  delete productFilters.inputColor;
  delete productFilters.inputSize;
  delete productFilters.inputProductLine;
  delete productFilters.inputProductType;
  delete productFilters.inputSupplierType;
  delete productFilters.inputTaxType;
  delete productFilters.inputRetailPrice;
  delete productFilters.inputRetailPriceOperator;
  delete productFilters.inputRetailPrice2;
  delete productFilters.inputStatus;
  delete productFilters.inputCategory;
  delete productFilters.inputSupplier;
  delete productFilters.inputBrand;

  let productFilterKeys = Object.keys(productFilters);
  let basicFilters = {};
  let filterLabels = {};

  parameterKeys.forEach((key) => {
    let currentKey;
    let text;
    if(key === 'isFormat' ){
      currentKey = parameters[key];
      basicFilters["format"] = formatOptions.filter(({ key }) => key == currentKey)[0].value;
    }
    if(key === 'status'){
      basicFilters["status"] = parameters[key];
    }
    if(key === 'group_by' || key ==='group'){
      basicFilters["group_by"] = parameters[key].split("_")[0];
    }
    if(key === 'order'){
      text = parameters[key].split("_")[0];
      if (parameters[key] === "grouper_id") text = basicFilters["group_by"];
      if (parameters[key] === "id") text = "Document ID";
      basicFilters["sort_by"] = text;
    }
    if(key === 'sort_by'){
      basicFilters["sort_by"] = parameters[key].split("_")[0];
    }
    if(key === 'by' || key ==='sort_type'){
      basicFilters["sort_by"] = `${basicFilters["sort_by"]}(${_.upperCase(parameters[key])})`;
    }
    if(key === 'display'){
      currentKey = parameters[key];
      basicFilters["display"] = displayOptions.filter(({ key }) => key == currentKey )[0].value;
    } 

    if(key === 'property_tag'){
        basicFilters["property_tag"] = parameterKeys[key];
    }
  });

  let filterKeys = Object.keys(basicFilters);
  let advancedFilters = productFilterKeys
    .filter(
      (key) => productFilters[key] !== null && productFilters[key].length !== 0
    )
    .map((fKey) => {
      let keyInstance = fKey;
      if(fKey.includes('_name')){
        fKey = `[${_.startCase(fKey.replace("_name", ""))} : ${ productFilters[keyInstance] }]`;
      }else if(fKey.includes('selected')){
        fKey = `[${_.startCase(fKey.replace("selected", ""))} : ${ productFilters[keyInstance].join(', ') }]`;
      }else if( fKey.includes('input')){
        fKey = `[${_.startCase(fKey.replace("input", ""))} : ${ productFilters[keyInstance] }]`;
      }else{
        fKey = `[${_.startCase(fKey)} : ${ productFilters[keyInstance] }]`;
      }
      return fKey;
    });
  filterLabels["basic"] = filterKeys
    .map(
      (key) => `[${_.capitalize(key.replace("_", " "))}: ${basicFilters[key]}]`
    )
    .join(" | ");
  filterLabels["advance"] = advancedFilters.join(" | ");
  // secureStorage.setItem("productFilters", {});
  return filterLabels;
};

export default reportUtils;
export {
  dissectReportFilters
}